export function findParticipantNameById(participants, id) {
  const obj = participants.find((obj) => obj.id === id);
  if (obj) {
    return `${obj.first_name} ${obj.last_name}`;
  }
  return null;
}
